// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/HostModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { StringValue } from "../../../google/protobuf/wrappers";
import { PagingInfo, Timeframe, timeframeFromJSON, timeframeToJSON } from "./SystemModels";

export const protobufPackage = "daisi.protos.v1";

export enum HostStatus {
  Unknown = 0,
  Online = 1,
  Offline = 2,
  Maintenance = 3,
  Archived = 4,
  UNRECOGNIZED = -1,
}

export function hostStatusFromJSON(object: any): HostStatus {
  switch (object) {
    case 0:
    case "Unknown":
      return HostStatus.Unknown;
    case 1:
    case "Online":
      return HostStatus.Online;
    case 2:
    case "Offline":
      return HostStatus.Offline;
    case 3:
    case "Maintenance":
      return HostStatus.Maintenance;
    case 4:
    case "Archived":
      return HostStatus.Archived;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HostStatus.UNRECOGNIZED;
  }
}

export function hostStatusToJSON(object: HostStatus): string {
  switch (object) {
    case HostStatus.Unknown:
      return "Unknown";
    case HostStatus.Online:
      return "Online";
    case HostStatus.Offline:
      return "Offline";
    case HostStatus.Maintenance:
      return "Maintenance";
    case HostStatus.Archived:
      return "Archived";
    case HostStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetHostsRequest {
  Paging?: PagingInfo | undefined;
}

export interface GetHostsResponse {
  Hosts: Host[];
  TotalCount: number;
}

export interface UpdateHostRequest {
  Host?: Host | undefined;
}

export interface UpdateHostResponse {
  Success: boolean;
  Message: string;
}

export interface RegisterHostRequest {
  Host?: Host | undefined;
}

export interface RegisterHostResponse {
  SecretKey: string;
  HostId: string;
}

export interface GetSecretKeyRequest {
  HostId: string;
}

export interface GetSecretKeyResponse {
  SecretKey: string;
}

export interface ArchiveHostRequest {
  HostId: string;
}

export interface ArchiveHostResponse {
  Success: boolean;
}

export interface GetHostStatsRequest {
  HostId: string;
  Timeframe: Timeframe;
  Date?: Date | undefined;
}

export interface GetHostStatsResponse {
  Stats: HostStat[];
}

export interface Host {
  Id: string;
  Name: string;
  IpAddress?: string | undefined;
  Port: number;
  DateStarted?: Date | undefined;
  DateStopped?: Date | undefined;
  DateLastHeartbeat?: Date | undefined;
  DateLastSession?: Date | undefined;
  OperatingSystem?: string | undefined;
  OperatingSystemVersion?: string | undefined;
  Status: HostStatus;
  Region: string;
  DirectConnect: boolean;
  PeerConnect: boolean;
  AppVersion?: string | undefined;
  ReleaseGroup?: string | undefined;
}

export interface HostStat {
  HostId: string;
  NetworkId: string;
  TokenCount: Long;
  SecondsProcessingTokens: Long;
  Timeframe: Timeframe;
  Date?: Date | undefined;
  Part?: number | undefined;
}

export interface DriveSettings {
  DrivePath: string;
  MaxDriveStorageBytes: Long;
  VectorDbEnabled: boolean;
  MaxVectorDbAccounts: number;
}

function createBaseGetHostsRequest(): GetHostsRequest {
  return { Paging: undefined };
}

export const GetHostsRequest: MessageFns<GetHostsRequest> = {
  encode(message: GetHostsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHostsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHostsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHostsRequest {
    return { Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined };
  },

  toJSON(message: GetHostsRequest): unknown {
    const obj: any = {};
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHostsRequest>, I>>(base?: I): GetHostsRequest {
    return GetHostsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHostsRequest>, I>>(object: I): GetHostsRequest {
    const message = createBaseGetHostsRequest();
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    return message;
  },
};

function createBaseGetHostsResponse(): GetHostsResponse {
  return { Hosts: [], TotalCount: 0 };
}

export const GetHostsResponse: MessageFns<GetHostsResponse> = {
  encode(message: GetHostsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Hosts) {
      Host.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHostsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHostsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Hosts.push(Host.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHostsResponse {
    return {
      Hosts: globalThis.Array.isArray(object?.Hosts) ? object.Hosts.map((e: any) => Host.fromJSON(e)) : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: GetHostsResponse): unknown {
    const obj: any = {};
    if (message.Hosts?.length) {
      obj.Hosts = message.Hosts.map((e) => Host.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHostsResponse>, I>>(base?: I): GetHostsResponse {
    return GetHostsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHostsResponse>, I>>(object: I): GetHostsResponse {
    const message = createBaseGetHostsResponse();
    message.Hosts = object.Hosts?.map((e) => Host.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseUpdateHostRequest(): UpdateHostRequest {
  return { Host: undefined };
}

export const UpdateHostRequest: MessageFns<UpdateHostRequest> = {
  encode(message: UpdateHostRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Host !== undefined) {
      Host.encode(message.Host, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateHostRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateHostRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Host = Host.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateHostRequest {
    return { Host: isSet(object.Host) ? Host.fromJSON(object.Host) : undefined };
  },

  toJSON(message: UpdateHostRequest): unknown {
    const obj: any = {};
    if (message.Host !== undefined) {
      obj.Host = Host.toJSON(message.Host);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateHostRequest>, I>>(base?: I): UpdateHostRequest {
    return UpdateHostRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateHostRequest>, I>>(object: I): UpdateHostRequest {
    const message = createBaseUpdateHostRequest();
    message.Host = (object.Host !== undefined && object.Host !== null) ? Host.fromPartial(object.Host) : undefined;
    return message;
  },
};

function createBaseUpdateHostResponse(): UpdateHostResponse {
  return { Success: false, Message: "" };
}

export const UpdateHostResponse: MessageFns<UpdateHostResponse> = {
  encode(message: UpdateHostResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== "") {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateHostResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateHostResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateHostResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : "",
    };
  },

  toJSON(message: UpdateHostResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== "") {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateHostResponse>, I>>(base?: I): UpdateHostResponse {
    return UpdateHostResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateHostResponse>, I>>(object: I): UpdateHostResponse {
    const message = createBaseUpdateHostResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? "";
    return message;
  },
};

function createBaseRegisterHostRequest(): RegisterHostRequest {
  return { Host: undefined };
}

export const RegisterHostRequest: MessageFns<RegisterHostRequest> = {
  encode(message: RegisterHostRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Host !== undefined) {
      Host.encode(message.Host, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegisterHostRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterHostRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Host = Host.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterHostRequest {
    return { Host: isSet(object.Host) ? Host.fromJSON(object.Host) : undefined };
  },

  toJSON(message: RegisterHostRequest): unknown {
    const obj: any = {};
    if (message.Host !== undefined) {
      obj.Host = Host.toJSON(message.Host);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterHostRequest>, I>>(base?: I): RegisterHostRequest {
    return RegisterHostRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterHostRequest>, I>>(object: I): RegisterHostRequest {
    const message = createBaseRegisterHostRequest();
    message.Host = (object.Host !== undefined && object.Host !== null) ? Host.fromPartial(object.Host) : undefined;
    return message;
  },
};

function createBaseRegisterHostResponse(): RegisterHostResponse {
  return { SecretKey: "", HostId: "" };
}

export const RegisterHostResponse: MessageFns<RegisterHostResponse> = {
  encode(message: RegisterHostResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SecretKey !== "") {
      writer.uint32(10).string(message.SecretKey);
    }
    if (message.HostId !== "") {
      writer.uint32(18).string(message.HostId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegisterHostResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterHostResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterHostResponse {
    return {
      SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "",
      HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "",
    };
  },

  toJSON(message: RegisterHostResponse): unknown {
    const obj: any = {};
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterHostResponse>, I>>(base?: I): RegisterHostResponse {
    return RegisterHostResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterHostResponse>, I>>(object: I): RegisterHostResponse {
    const message = createBaseRegisterHostResponse();
    message.SecretKey = object.SecretKey ?? "";
    message.HostId = object.HostId ?? "";
    return message;
  },
};

function createBaseGetSecretKeyRequest(): GetSecretKeyRequest {
  return { HostId: "" };
}

export const GetSecretKeyRequest: MessageFns<GetSecretKeyRequest> = {
  encode(message: GetSecretKeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.HostId !== "") {
      writer.uint32(10).string(message.HostId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSecretKeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSecretKeyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSecretKeyRequest {
    return { HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "" };
  },

  toJSON(message: GetSecretKeyRequest): unknown {
    const obj: any = {};
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSecretKeyRequest>, I>>(base?: I): GetSecretKeyRequest {
    return GetSecretKeyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSecretKeyRequest>, I>>(object: I): GetSecretKeyRequest {
    const message = createBaseGetSecretKeyRequest();
    message.HostId = object.HostId ?? "";
    return message;
  },
};

function createBaseGetSecretKeyResponse(): GetSecretKeyResponse {
  return { SecretKey: "" };
}

export const GetSecretKeyResponse: MessageFns<GetSecretKeyResponse> = {
  encode(message: GetSecretKeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.SecretKey !== "") {
      writer.uint32(10).string(message.SecretKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSecretKeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSecretKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.SecretKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSecretKeyResponse {
    return { SecretKey: isSet(object.SecretKey) ? globalThis.String(object.SecretKey) : "" };
  },

  toJSON(message: GetSecretKeyResponse): unknown {
    const obj: any = {};
    if (message.SecretKey !== "") {
      obj.SecretKey = message.SecretKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSecretKeyResponse>, I>>(base?: I): GetSecretKeyResponse {
    return GetSecretKeyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSecretKeyResponse>, I>>(object: I): GetSecretKeyResponse {
    const message = createBaseGetSecretKeyResponse();
    message.SecretKey = object.SecretKey ?? "";
    return message;
  },
};

function createBaseArchiveHostRequest(): ArchiveHostRequest {
  return { HostId: "" };
}

export const ArchiveHostRequest: MessageFns<ArchiveHostRequest> = {
  encode(message: ArchiveHostRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.HostId !== "") {
      writer.uint32(10).string(message.HostId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveHostRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveHostRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveHostRequest {
    return { HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "" };
  },

  toJSON(message: ArchiveHostRequest): unknown {
    const obj: any = {};
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArchiveHostRequest>, I>>(base?: I): ArchiveHostRequest {
    return ArchiveHostRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArchiveHostRequest>, I>>(object: I): ArchiveHostRequest {
    const message = createBaseArchiveHostRequest();
    message.HostId = object.HostId ?? "";
    return message;
  },
};

function createBaseArchiveHostResponse(): ArchiveHostResponse {
  return { Success: false };
}

export const ArchiveHostResponse: MessageFns<ArchiveHostResponse> = {
  encode(message: ArchiveHostResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveHostResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveHostResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveHostResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: ArchiveHostResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArchiveHostResponse>, I>>(base?: I): ArchiveHostResponse {
    return ArchiveHostResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArchiveHostResponse>, I>>(object: I): ArchiveHostResponse {
    const message = createBaseArchiveHostResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

function createBaseGetHostStatsRequest(): GetHostStatsRequest {
  return { HostId: "", Timeframe: 0, Date: undefined };
}

export const GetHostStatsRequest: MessageFns<GetHostStatsRequest> = {
  encode(message: GetHostStatsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.HostId !== "") {
      writer.uint32(10).string(message.HostId);
    }
    if (message.Timeframe !== 0) {
      writer.uint32(16).int32(message.Timeframe);
    }
    if (message.Date !== undefined) {
      Timestamp.encode(toTimestamp(message.Date), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHostStatsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHostStatsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Timeframe = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Date = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHostStatsRequest {
    return {
      HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "",
      Timeframe: isSet(object.Timeframe) ? timeframeFromJSON(object.Timeframe) : 0,
      Date: isSet(object.Date) ? fromJsonTimestamp(object.Date) : undefined,
    };
  },

  toJSON(message: GetHostStatsRequest): unknown {
    const obj: any = {};
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    if (message.Timeframe !== 0) {
      obj.Timeframe = timeframeToJSON(message.Timeframe);
    }
    if (message.Date !== undefined) {
      obj.Date = message.Date.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHostStatsRequest>, I>>(base?: I): GetHostStatsRequest {
    return GetHostStatsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHostStatsRequest>, I>>(object: I): GetHostStatsRequest {
    const message = createBaseGetHostStatsRequest();
    message.HostId = object.HostId ?? "";
    message.Timeframe = object.Timeframe ?? 0;
    message.Date = object.Date ?? undefined;
    return message;
  },
};

function createBaseGetHostStatsResponse(): GetHostStatsResponse {
  return { Stats: [] };
}

export const GetHostStatsResponse: MessageFns<GetHostStatsResponse> = {
  encode(message: GetHostStatsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Stats) {
      HostStat.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHostStatsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHostStatsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Stats.push(HostStat.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHostStatsResponse {
    return { Stats: globalThis.Array.isArray(object?.Stats) ? object.Stats.map((e: any) => HostStat.fromJSON(e)) : [] };
  },

  toJSON(message: GetHostStatsResponse): unknown {
    const obj: any = {};
    if (message.Stats?.length) {
      obj.Stats = message.Stats.map((e) => HostStat.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetHostStatsResponse>, I>>(base?: I): GetHostStatsResponse {
    return GetHostStatsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetHostStatsResponse>, I>>(object: I): GetHostStatsResponse {
    const message = createBaseGetHostStatsResponse();
    message.Stats = object.Stats?.map((e) => HostStat.fromPartial(e)) || [];
    return message;
  },
};

function createBaseHost(): Host {
  return {
    Id: "",
    Name: "",
    IpAddress: undefined,
    Port: 0,
    DateStarted: undefined,
    DateStopped: undefined,
    DateLastHeartbeat: undefined,
    DateLastSession: undefined,
    OperatingSystem: undefined,
    OperatingSystemVersion: undefined,
    Status: 0,
    Region: "",
    DirectConnect: false,
    PeerConnect: false,
    AppVersion: undefined,
    ReleaseGroup: undefined,
  };
}

export const Host: MessageFns<Host> = {
  encode(message: Host, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.IpAddress !== undefined) {
      StringValue.encode({ value: message.IpAddress! }, writer.uint32(26).fork()).join();
    }
    if (message.Port !== 0) {
      writer.uint32(32).int32(message.Port);
    }
    if (message.DateStarted !== undefined) {
      Timestamp.encode(toTimestamp(message.DateStarted), writer.uint32(42).fork()).join();
    }
    if (message.DateStopped !== undefined) {
      Timestamp.encode(toTimestamp(message.DateStopped), writer.uint32(50).fork()).join();
    }
    if (message.DateLastHeartbeat !== undefined) {
      Timestamp.encode(toTimestamp(message.DateLastHeartbeat), writer.uint32(58).fork()).join();
    }
    if (message.DateLastSession !== undefined) {
      Timestamp.encode(toTimestamp(message.DateLastSession), writer.uint32(66).fork()).join();
    }
    if (message.OperatingSystem !== undefined) {
      StringValue.encode({ value: message.OperatingSystem! }, writer.uint32(74).fork()).join();
    }
    if (message.OperatingSystemVersion !== undefined) {
      StringValue.encode({ value: message.OperatingSystemVersion! }, writer.uint32(82).fork()).join();
    }
    if (message.Status !== 0) {
      writer.uint32(88).int32(message.Status);
    }
    if (message.Region !== "") {
      writer.uint32(98).string(message.Region);
    }
    if (message.DirectConnect !== false) {
      writer.uint32(104).bool(message.DirectConnect);
    }
    if (message.PeerConnect !== false) {
      writer.uint32(112).bool(message.PeerConnect);
    }
    if (message.AppVersion !== undefined) {
      StringValue.encode({ value: message.AppVersion! }, writer.uint32(122).fork()).join();
    }
    if (message.ReleaseGroup !== undefined) {
      StringValue.encode({ value: message.ReleaseGroup! }, writer.uint32(130).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Host {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHost();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.IpAddress = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.Port = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.DateStarted = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.DateStopped = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.DateLastHeartbeat = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.DateLastSession = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.OperatingSystem = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.OperatingSystemVersion = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.Status = reader.int32() as any;
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.Region = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.DirectConnect = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.PeerConnect = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.AppVersion = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.ReleaseGroup = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Host {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      IpAddress: isSet(object.IpAddress) ? String(object.IpAddress) : undefined,
      Port: isSet(object.Port) ? globalThis.Number(object.Port) : 0,
      DateStarted: isSet(object.DateStarted) ? fromJsonTimestamp(object.DateStarted) : undefined,
      DateStopped: isSet(object.DateStopped) ? fromJsonTimestamp(object.DateStopped) : undefined,
      DateLastHeartbeat: isSet(object.DateLastHeartbeat) ? fromJsonTimestamp(object.DateLastHeartbeat) : undefined,
      DateLastSession: isSet(object.DateLastSession) ? fromJsonTimestamp(object.DateLastSession) : undefined,
      OperatingSystem: isSet(object.OperatingSystem) ? String(object.OperatingSystem) : undefined,
      OperatingSystemVersion: isSet(object.OperatingSystemVersion) ? String(object.OperatingSystemVersion) : undefined,
      Status: isSet(object.Status) ? hostStatusFromJSON(object.Status) : 0,
      Region: isSet(object.Region) ? globalThis.String(object.Region) : "",
      DirectConnect: isSet(object.DirectConnect) ? globalThis.Boolean(object.DirectConnect) : false,
      PeerConnect: isSet(object.PeerConnect) ? globalThis.Boolean(object.PeerConnect) : false,
      AppVersion: isSet(object.AppVersion) ? String(object.AppVersion) : undefined,
      ReleaseGroup: isSet(object.ReleaseGroup) ? String(object.ReleaseGroup) : undefined,
    };
  },

  toJSON(message: Host): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.IpAddress !== undefined) {
      obj.IpAddress = message.IpAddress;
    }
    if (message.Port !== 0) {
      obj.Port = Math.round(message.Port);
    }
    if (message.DateStarted !== undefined) {
      obj.DateStarted = message.DateStarted.toISOString();
    }
    if (message.DateStopped !== undefined) {
      obj.DateStopped = message.DateStopped.toISOString();
    }
    if (message.DateLastHeartbeat !== undefined) {
      obj.DateLastHeartbeat = message.DateLastHeartbeat.toISOString();
    }
    if (message.DateLastSession !== undefined) {
      obj.DateLastSession = message.DateLastSession.toISOString();
    }
    if (message.OperatingSystem !== undefined) {
      obj.OperatingSystem = message.OperatingSystem;
    }
    if (message.OperatingSystemVersion !== undefined) {
      obj.OperatingSystemVersion = message.OperatingSystemVersion;
    }
    if (message.Status !== 0) {
      obj.Status = hostStatusToJSON(message.Status);
    }
    if (message.Region !== "") {
      obj.Region = message.Region;
    }
    if (message.DirectConnect !== false) {
      obj.DirectConnect = message.DirectConnect;
    }
    if (message.PeerConnect !== false) {
      obj.PeerConnect = message.PeerConnect;
    }
    if (message.AppVersion !== undefined) {
      obj.AppVersion = message.AppVersion;
    }
    if (message.ReleaseGroup !== undefined) {
      obj.ReleaseGroup = message.ReleaseGroup;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Host>, I>>(base?: I): Host {
    return Host.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Host>, I>>(object: I): Host {
    const message = createBaseHost();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    message.IpAddress = object.IpAddress ?? undefined;
    message.Port = object.Port ?? 0;
    message.DateStarted = object.DateStarted ?? undefined;
    message.DateStopped = object.DateStopped ?? undefined;
    message.DateLastHeartbeat = object.DateLastHeartbeat ?? undefined;
    message.DateLastSession = object.DateLastSession ?? undefined;
    message.OperatingSystem = object.OperatingSystem ?? undefined;
    message.OperatingSystemVersion = object.OperatingSystemVersion ?? undefined;
    message.Status = object.Status ?? 0;
    message.Region = object.Region ?? "";
    message.DirectConnect = object.DirectConnect ?? false;
    message.PeerConnect = object.PeerConnect ?? false;
    message.AppVersion = object.AppVersion ?? undefined;
    message.ReleaseGroup = object.ReleaseGroup ?? undefined;
    return message;
  },
};

function createBaseHostStat(): HostStat {
  return {
    HostId: "",
    NetworkId: "",
    TokenCount: Long.ZERO,
    SecondsProcessingTokens: Long.ZERO,
    Timeframe: 0,
    Date: undefined,
    Part: undefined,
  };
}

export const HostStat: MessageFns<HostStat> = {
  encode(message: HostStat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.HostId !== "") {
      writer.uint32(10).string(message.HostId);
    }
    if (message.NetworkId !== "") {
      writer.uint32(18).string(message.NetworkId);
    }
    if (!message.TokenCount.equals(Long.ZERO)) {
      writer.uint32(24).int64(message.TokenCount.toString());
    }
    if (!message.SecondsProcessingTokens.equals(Long.ZERO)) {
      writer.uint32(32).int64(message.SecondsProcessingTokens.toString());
    }
    if (message.Timeframe !== 0) {
      writer.uint32(40).int32(message.Timeframe);
    }
    if (message.Date !== undefined) {
      Timestamp.encode(toTimestamp(message.Date), writer.uint32(50).fork()).join();
    }
    if (message.Part !== undefined) {
      writer.uint32(56).int32(message.Part);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostStat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostStat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.HostId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.NetworkId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.TokenCount = Long.fromString(reader.int64().toString());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.SecondsProcessingTokens = Long.fromString(reader.int64().toString());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.Timeframe = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.Date = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.Part = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostStat {
    return {
      HostId: isSet(object.HostId) ? globalThis.String(object.HostId) : "",
      NetworkId: isSet(object.NetworkId) ? globalThis.String(object.NetworkId) : "",
      TokenCount: isSet(object.TokenCount) ? Long.fromValue(object.TokenCount) : Long.ZERO,
      SecondsProcessingTokens: isSet(object.SecondsProcessingTokens)
        ? Long.fromValue(object.SecondsProcessingTokens)
        : Long.ZERO,
      Timeframe: isSet(object.Timeframe) ? timeframeFromJSON(object.Timeframe) : 0,
      Date: isSet(object.Date) ? fromJsonTimestamp(object.Date) : undefined,
      Part: isSet(object.Part) ? globalThis.Number(object.Part) : undefined,
    };
  },

  toJSON(message: HostStat): unknown {
    const obj: any = {};
    if (message.HostId !== "") {
      obj.HostId = message.HostId;
    }
    if (message.NetworkId !== "") {
      obj.NetworkId = message.NetworkId;
    }
    if (!message.TokenCount.equals(Long.ZERO)) {
      obj.TokenCount = (message.TokenCount || Long.ZERO).toString();
    }
    if (!message.SecondsProcessingTokens.equals(Long.ZERO)) {
      obj.SecondsProcessingTokens = (message.SecondsProcessingTokens || Long.ZERO).toString();
    }
    if (message.Timeframe !== 0) {
      obj.Timeframe = timeframeToJSON(message.Timeframe);
    }
    if (message.Date !== undefined) {
      obj.Date = message.Date.toISOString();
    }
    if (message.Part !== undefined) {
      obj.Part = Math.round(message.Part);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostStat>, I>>(base?: I): HostStat {
    return HostStat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostStat>, I>>(object: I): HostStat {
    const message = createBaseHostStat();
    message.HostId = object.HostId ?? "";
    message.NetworkId = object.NetworkId ?? "";
    message.TokenCount = (object.TokenCount !== undefined && object.TokenCount !== null)
      ? Long.fromValue(object.TokenCount)
      : Long.ZERO;
    message.SecondsProcessingTokens =
      (object.SecondsProcessingTokens !== undefined && object.SecondsProcessingTokens !== null)
        ? Long.fromValue(object.SecondsProcessingTokens)
        : Long.ZERO;
    message.Timeframe = object.Timeframe ?? 0;
    message.Date = object.Date ?? undefined;
    message.Part = object.Part ?? undefined;
    return message;
  },
};

function createBaseDriveSettings(): DriveSettings {
  return { DrivePath: "", MaxDriveStorageBytes: Long.ZERO, VectorDbEnabled: false, MaxVectorDbAccounts: 0 };
}

export const DriveSettings: MessageFns<DriveSettings> = {
  encode(message: DriveSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.DrivePath !== "") {
      writer.uint32(10).string(message.DrivePath);
    }
    if (!message.MaxDriveStorageBytes.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.MaxDriveStorageBytes.toString());
    }
    if (message.VectorDbEnabled !== false) {
      writer.uint32(24).bool(message.VectorDbEnabled);
    }
    if (message.MaxVectorDbAccounts !== 0) {
      writer.uint32(32).int32(message.MaxVectorDbAccounts);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DriveSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDriveSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.DrivePath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.MaxDriveStorageBytes = Long.fromString(reader.int64().toString());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.VectorDbEnabled = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.MaxVectorDbAccounts = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DriveSettings {
    return {
      DrivePath: isSet(object.DrivePath) ? globalThis.String(object.DrivePath) : "",
      MaxDriveStorageBytes: isSet(object.MaxDriveStorageBytes)
        ? Long.fromValue(object.MaxDriveStorageBytes)
        : Long.ZERO,
      VectorDbEnabled: isSet(object.VectorDbEnabled) ? globalThis.Boolean(object.VectorDbEnabled) : false,
      MaxVectorDbAccounts: isSet(object.MaxVectorDbAccounts) ? globalThis.Number(object.MaxVectorDbAccounts) : 0,
    };
  },

  toJSON(message: DriveSettings): unknown {
    const obj: any = {};
    if (message.DrivePath !== "") {
      obj.DrivePath = message.DrivePath;
    }
    if (!message.MaxDriveStorageBytes.equals(Long.ZERO)) {
      obj.MaxDriveStorageBytes = (message.MaxDriveStorageBytes || Long.ZERO).toString();
    }
    if (message.VectorDbEnabled !== false) {
      obj.VectorDbEnabled = message.VectorDbEnabled;
    }
    if (message.MaxVectorDbAccounts !== 0) {
      obj.MaxVectorDbAccounts = Math.round(message.MaxVectorDbAccounts);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DriveSettings>, I>>(base?: I): DriveSettings {
    return DriveSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DriveSettings>, I>>(object: I): DriveSettings {
    const message = createBaseDriveSettings();
    message.DrivePath = object.DrivePath ?? "";
    message.MaxDriveStorageBytes = (object.MaxDriveStorageBytes !== undefined && object.MaxDriveStorageBytes !== null)
      ? Long.fromValue(object.MaxDriveStorageBytes)
      : Long.ZERO;
    message.VectorDbEnabled = object.VectorDbEnabled ?? false;
    message.MaxVectorDbAccounts = object.MaxVectorDbAccounts ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
